// Brand tokens — see CLAUDE.md for usage rules.
export const colors = {
  pageBackground: '#F5E9FF',
  accentPurple: '#8553D1',
  lightPurple: '#C9A8F0',
  black: '#000000',
  white: '#ffffff',
  textPrimary: '#000000',
  textSecondary: '#666666',
  textMuted: '#999999',
  actionButton: '#66616C',
  defaultAvatar: '#D3D3D3',
  borderLight: '#e0e0e0',
};
